<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey === item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'ProfileInventoriesShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'profile_inventories', tabName: 'Profile资源入库' },
        { routeName: 'profile_inventory_import_records', tabName: '入库记录' },
        { routeName: 'profile_datas', tabName: 'ProfileData资源' }
      ]
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.activeKey = route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
